import React, {Fragment, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getIsTermsAccepted, getLoginPayload, getSessionState} from "modules/selectors";
import {userLogin} from "modules/actions";
import {Preloader} from "components/Preloader";
import {RequestState} from "modules/enums";
import {eq} from "lodash";
import {Navigate} from "react-router-dom";

interface IProps {
	children: React.ReactElement;
	checkTerms?: boolean;
}

export const HOCLoginService: React.FC<IProps> = ({children, checkTerms = true}) => {
	const dispatch = useDispatch();
	const loginPayload = useSelector(getLoginPayload);
	const isTermsAccepted = useSelector(getIsTermsAccepted) || !checkTerms;
	const session = useSelector(getSessionState);
	const isRequestedSession = eq(session, RequestState.Requested);

	useEffect(() => {
		if (loginPayload.uid && isTermsAccepted) {
			dispatch(userLogin(loginPayload));
		}
	}, [dispatch, loginPayload, isTermsAccepted]);

	if (isRequestedSession || !loginPayload.uid) {
		return <Preloader fixed />;
	}

	return <Fragment>{isTermsAccepted ? children : <Navigate to={"/"} />}</Fragment>;
};
